/**
 * 分区计量模块（src/views/DMAPartitionMetering）英文映射 · 第 2 组
 * 范围：PipelineNetMap/PipeNetwork 目录（RenderingConfiguration、ReviewManagement、
 * PipeNetworkOverview 及 components 下的 13 个组件）
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '提示': 'Notice',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '编辑': 'Edit',
  '删除': 'Delete',
  '详情': 'Details',
  '操作': 'Action',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '是': 'Yes',
  '否': 'No',
  '确定删除吗?': 'Are you sure you want to delete?',
  '名称': 'Name',
  '请输入名称': 'Please enter name',
  '备注': 'Remark',
  '请输入备注': 'Please enter remark',
  '类型': 'Type',
  '编号': 'No.',
  '未知': 'Unknown',
  '保存': 'Save',
  '添加': 'Add',
  '预览': 'Preview',
  '上传': 'Upload',
  '颜色': 'Color',
  '操作失败': 'Operation failed',
  // ── 渲染配置 RenderingConfiguration ──
  '渲染配置': 'Rendering Configuration',
  '复制': 'Copy',
  '启用': 'Enabled',
  '启用成功！': 'Enabled successfully!',
  '(复制)': ' (Copy)',
  '【{code}】': '[{code}]',
  '请选择左侧项目！': 'Please select a project on the left!',
  '图标配置': 'Icon Configuration',
  '管径渲染配置': 'Pipe Diameter Rendering Configuration',
  '压力渲染配置': 'Pressure Rendering Configuration',
  '分级渲染配置': 'Hierarchical Rendering Configuration',
  '图标': 'Icon',
  '线宽': 'Line Width',
  '请输入线宽': 'Enter line width',
  '流速下限': 'Flow Velocity Lower Limit',
  '流速上限': 'Flow Velocity Upper Limit',
  '请输入流速下限': 'Enter flow velocity lower limit',
  '请输入流速上限': 'Enter flow velocity upper limit',
  '管径下限': 'Diameter Lower Limit',
  '管径上限': 'Diameter Upper Limit',
  '请输入管径下限': 'Enter diameter lower limit',
  '请输入管径上限': 'Enter diameter upper limit',
  '主颜色': 'Primary Color',
  '分段颜色': 'Segment Color',
  '压力下限': 'Pressure Lower Limit',
  '压力上限': 'Pressure Upper Limit',
  '请输入压力下限': 'Enter pressure lower limit',
  '请输入压力上限': 'Enter pressure upper limit',
  '层级': 'Zoom Level',
  '请输入层级': 'Enter zoom level',
  // ── 项目 / 拓扑 AddProjectModal / AddTopologyModal ──
  '项目名称': 'Project Name',
  '请输入项目名称': 'Please enter project name',
  '项目代码': 'Project Code',
  '请输入项目代码': 'Please enter project code',
  '新增项目': 'Add Project',
  '拓扑名称': 'Topology Name',
  '请输入拓扑名称': 'Please enter topology name',
  '新增拓扑': 'Add Topology',
  '请输入拓扑代码': 'Please enter topology code',
  '编辑成功！': 'Edited successfully!',
  '新增成功！': 'Added successfully!',
  // ── 地图编辑面板 AddNodeAndLineIndex ──
  '打开编辑': 'Open Edit',
  '取消编辑': 'Cancel Edit',
  '选择类型': 'Select Type',
  '节点': 'Node',
  '管线': 'Pipeline',
  '区域': 'Area',
  '操作类型': 'Operation Type',
  '录入方式': 'Input Method',
  '地图绘制': 'Map Drawing',
  '坐标录入': 'Coordinate Entry',
  '坐标': 'Coordinate',
  'X坐标': 'X Coordinate',
  'Y坐标': 'Y Coordinate',
  '起点坐标': 'Start Coordinate',
  '终点坐标': 'End Coordinate',
  '捕捉设置': 'Snap Settings',
  '捕捉开关': 'Snap Switch',
  '捕捉容差': 'Snap Tolerance',
  // ── 图片上传 JImageUpload ──
  '请上传图片': 'Please upload an image',
  '图片大小不能超过 10MB': 'Image size cannot exceed 10MB',
  '上传失败.': 'Upload failed.',
  // ── 节点 / 管道属性 NodeDetailsModal / PipelineDetailsModal ──
  '节点属性编辑': 'Edit Node Properties',
  '管道属性编辑': 'Edit Pipe Properties',
  '编辑节点': 'Edit Node',
  '新增节点': 'Add Node',
  '请选择类型': 'Please select type',
  '请输入': 'Please enter',
  '项目编码': 'Project Code',
  '拓扑编码': 'Topology Code',
  '节点编码': 'Node Code',
  '节点名称': 'Node Name',
  '节点类型': 'Node Type',
  '管道编码': 'Pipe Code',
  '管道名称': 'Pipe Name',
  '管道材质': 'Pipe Material',
  '高程': 'Elevation',
  'DMA标记': 'DMA Flag',
  // ── 审核 Node/ReviewListTable / ReviewManagement ──
  '审核状态': 'Review Status',
  '草稿': 'Draft',
  '审核中': 'Under Review',
  '审核通过': 'Approved',
  '审核失败': 'Rejected',
  '提交': 'Submit',
  '提交成功': 'Submitted successfully',
  '提交失败': 'Submission failed',
  '撤回申请': 'Withdraw Application',
  '通过': 'Approve',
  '驳回': 'Reject',
  '已驳回': 'Rejected',
  '更新申请': 'Update Application',
  '删除申请': 'Delete Application',
  '删除申请成功': 'Application deleted successfully',
  '删除申请失败': 'Failed to delete application',
  '共 {total} 条': 'Total {total} records',
  '未获取到拓扑参数，请稍后重试': 'Topology parameters not found, please try again later',
  '加载数据失败': 'Failed to load data',
  '确认提交': 'Confirm Submit',
  '确认删除': 'Confirm Deletion',
  '确认撤回': 'Confirm Withdrawal',
  '确认通过': 'Confirm Approval',
  '确认驳回': 'Confirm Rejection',
  '确定要提交节点 "{name}" 的审核申请吗？': 'Are you sure to submit the review application for node "{name}"?',
  '确定要删除节点 "{name}" 吗？': 'Are you sure to delete node "{name}"?',
  '确定要撤回节点 "{name}" 的申请吗？': 'Are you sure to withdraw the application for node "{name}"?',
  '确定要通过节点 "{name}" 的审核吗？': 'Are you sure to approve the review of node "{name}"?',
  '确定要驳回节点 "{name}" 的审核吗？': 'Are you sure to reject the review of node "{name}"?',
  '确定要删除节点 "{name}" 的申请吗？': 'Are you sure to delete the application for node "{name}"?',
  '请输入删除备注': 'Please enter delete remark',
  '删除成功': 'Deleted successfully',
  '删除失败': 'Deletion failed',
  '撤回成功': 'Withdrawn successfully',
  '撤回失败': 'Withdrawal failed',
  '未点击到管线，请重新点击管线': 'No pipeline clicked, please click a pipeline again',
  // ── 管网总览 PipeNetworkOverview ──
  '缩放级别': 'Zoom Level',
  '曲线图': 'Curve Chart',
  '编码': 'Code',
  '材质': 'Material',
  '管径': 'Pipe Diameter',
  '管长': 'Pipe Length',
}
